/* @import '../../global/app.css'; */
/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.article-body-container {
  @apply mx-auto;
}

.body-text-wrapper {
  @apply w-full;
}

.body-text {
  @apply w-full mx-auto;
}

/* Article Body Text Style */
.body-text h1, .body-text h2 {
  @apply text-ui-gray-1 text-3 sm:text-4 md:text-5 lg:text-6 font-semibold my-20px relative;

}
.body-text h2:before {
  @apply text-medium-blue bg-medium-blue h-4px -left-32px sm:-left-64px md:-left-100px xl:-left-120px w-20px sm:w-56px md:w-[80px] xl:w-[100px];
  content: "\0020"; /* Add a space character before the h2 */
  font-family: 'Font Awesome 5 Free'; /* Replace with your desired font */
  font-weight: 900;
  font-size: 1.25em;
  display: inline-block;
  text-align: center;
  position: absolute;
  transform: translateY(16px);
}

.body-text h3 {
  @apply text-ui-gray-1 text-2 md:text-3 lg:text-4 font-semibold my-20px;
}

.body-text a {
  @apply text-medium-blue underline -text-1 md:text-0 hover:text-dark-blue transition-colors cursor-pointer;
}

/* .body-text p + p {
  @apply mb-40px;
} */

.body-text p {
  @apply text-ui-gray-2 -text-1 md:text-0 mb-12px;
}

.body-text ul {
  @apply list-disc;
}

.body-text ol {
  @apply list-decimal marker:text-medium-blue;
}

.body-text li {
  @apply text-ui-gray-2 -text-1 md:text-0 mb-12px;
}


.body-text table {
  @apply w-fit h-auto mx-auto;
}

.body-text table td {
  @apply border border-ui-gray-4 px-8px py-12px;
}